import Image from "next/image";
import React from "react";
import CloseButton from "@/components/common/buttons/CloseButton";
import DailyLifetimeStats from "@/components/daily/DailyLifetimeStats";
import PanelButton, {TYPE_GO_BACK, TYPE_CONTINUE} from "@/components/panels/PanelButton";

const DailyLifetimeModal = ({data, onCancel, className}) => {
	return (
		<div className={`fixed top-0 right-0 bottom-0 left-0 
			flex items-center justify-center 
			z-50 ${className}
			bg-black bg-opacity-75
		`} onClick={onCancel}>
			<div className={`relative flex flex-col gap-4
				max-h-full max-w-xl
				overflow-y-auto bg-white bg-opacity-60
				rounded-lg shadow-2xl font-gReg text-primary
			`} onClick={(e)=>e.stopPropagation()}>
        <CloseButton onClick={onCancel} className="absolute top-2 right-2 z-50 text-primary" />
        <DailyLifetimeStats data={data} />
			</div>
		</div>
	);
}
 export default DailyLifetimeModal;
